import React from 'react'

class WkPanel extends React.Component {
    onClickTip () {
        if (this.props.onClickTip) {
            this.props.onClickTip()
        }
    }

    render() {
        return (
            <div className={`wk-panel ${this.props.className ? this.props.className : ''}`}>
                <div className="title wk-border-line-after wk-position-rlt">
                    <span className='title-text'>{this.props.title}</span>
                    {
                        !this.props.isHideTip && (
                            <span className="tip" onClick={e => this.onClickTip()}>
                                {this.props.tip}
                            </span>
                        )
                    }
                </div>
                <div className="content" style={this.props.isNoPadding ? {padding: 0} : {}}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default WkPanel


// WEBPACK FOOTER //
// ./src/components/wk/WkPanel.js